import { computed } from "vue";
import { translations } from "#blokkli-build/translations";
import { defaultLanguage, forceDefaultLanguage } from "#blokkli-build/config";
export default function(context) {
  const language = computed(() => {
    if (forceDefaultLanguage) {
      return defaultLanguage;
    }
    if (context?.value.language && translations[context.value.language]) {
      return context.value.language;
    }
    return defaultLanguage;
  });
  const currentTranslations = computed(() => {
    return translations[language.value] || {};
  });
  return (key, defaultValue) => {
    return currentTranslations.value[key] || defaultValue;
  };
}
